import SupplierLayout from '../../components/layout/SupplierLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { ShieldCheck, FileCheck, Clock } from 'lucide-react';
import { useSupplierAuth } from '../../context/SupplierAuthContext';

const SupplierCompliancePage = () => {
  const { user } = useSupplierAuth();

  const complianceItems = [
    { name: 'ISO 27001', status: 'pending', description: 'Upload uw ISO 27001 certificaat' },
    { name: 'NIS2 Compliance', status: 'pending', description: 'Toon aan dat u voldoet aan NIS2' },
    { name: 'AVG / GDPR', status: 'pending', description: 'Verwerkersovereenkomst en privacybeleid' },
  ];

  return (
    <SupplierLayout>
      <div className="space-y-6" data-testid="supplier-compliance-page">
        <div>
          <h1 className="text-xl font-bold text-black tracking-tight">Compliance</h1>
          <p className="text-sm text-neutral-500 mt-1">Beheer uw certificeringen en compliance-documenten</p>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <Card className="border-neutral-200 shadow-sm">
            <CardContent className="p-4 text-center">
              <p className="text-2xl font-bold text-black">0</p>
              <p className="text-xs text-neutral-500">Geverifieerd</p>
            </CardContent>
          </Card>
          <Card className="border-neutral-200 shadow-sm">
            <CardContent className="p-4 text-center">
              <p className="text-2xl font-bold text-amber-600">3</p>
              <p className="text-xs text-neutral-500">In afwachting</p>
            </CardContent>
          </Card>
          <Card className="border-neutral-200 shadow-sm">
            <CardContent className="p-4 text-center">
              <p className="text-2xl font-bold text-red-600">0</p>
              <p className="text-xs text-neutral-500">Verlopen</p>
            </CardContent>
          </Card>
        </div>

        <Card className="border-neutral-200 shadow-sm">
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-bold text-black flex items-center gap-2">
              <FileCheck className="h-4 w-4" strokeWidth={1.5} />
              Compliance-items
            </CardTitle>
            <CardDescription className="text-xs text-neutral-500">Uw certificeringen en compliance-status</CardDescription>
          </CardHeader>
          <CardContent className="p-0">
            <table className="w-full">
              <thead>
                <tr className="border-b border-neutral-200">
                  <th className="p-3 text-left text-[10px] font-bold uppercase tracking-wider text-neutral-500 bg-neutral-50">Certificering</th>
                  <th className="p-3 text-left text-[10px] font-bold uppercase tracking-wider text-neutral-500 bg-neutral-50">Omschrijving</th>
                  <th className="p-3 text-center text-[10px] font-bold uppercase tracking-wider text-neutral-500 bg-neutral-50">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-neutral-100">
                {complianceItems.map((item, i) => (
                  <tr key={i} className="hover:bg-neutral-50">
                    <td className="p-3 text-sm font-medium text-black">{item.name}</td>
                    <td className="p-3 text-xs text-neutral-600">{item.description}</td>
                    <td className="p-3 text-center">
                      <Badge className="bg-amber-100 text-amber-700 text-[10px] border-transparent">
                        <Clock className="h-3 w-3 mr-1" strokeWidth={1.5} />
                        In afwachting
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardContent>
        </Card>

        <Card className="border-blue-200 bg-blue-50/50 shadow-sm">
          <CardContent className="p-4 flex items-center gap-3">
            <div className="h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center shrink-0">
              <ShieldCheck className="h-5 w-5 text-blue-600" strokeWidth={1.5} />
            </div>
            <div>
              <p className="text-sm font-semibold text-blue-800">Document-upload binnenkort beschikbaar</p>
              <p className="text-xs text-blue-700">U kunt straks certificaten uploaden en automatisch laten verifiëren.</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </SupplierLayout>
  );
};

export default SupplierCompliancePage;
